export default __webpack_public_path__ + "static/compareItemImg2-d71396f89782c41a64021fc3aac8f648.png";